import { isDefined } from "@clipboard-health/util-ts";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import { CbhIcon } from "@src/appV2/components/CbhIcon/CbhIcon";
import { Text } from "@src/lib/ui-react";

import { useIsSmallScreen } from "../../hooks/useIsSmallScreen";
import { useShiftCardContext } from "../useShiftCard";
import { ShiftBoardLiveTrackerCardHeader } from "./CardHeader";
import { ShiftBoardLiveTrackerMapView } from "./MapView";

export function ShiftBoardLiveTracker() {
  const isSmallScreen = useIsSmallScreen();

  const {
    shift,
    isShiftEnded,
    isWorkerClockedIn,
    tripHasStarted,
    noTripInformationAvailable,
    isUrgentBookable,
    isUrgentShift,
  } = useShiftCardContext();
  const { trip, worker, deleted, isBillable } = shift;
  const { trackingUrl } = trip ?? {};

  if (!isDefined(worker)) {
    return null;
  }

  if (isUrgentShift && isUrgentBookable) {
    return null;
  }

  function shouldShowLiveTrackerView() {
    if (deleted || !isBillable) {
      return false;
    }

    if (isShiftEnded) {
      return false;
    }

    if (!tripHasStarted) {
      return false;
    }

    if (noTripInformationAvailable) {
      return false;
    }

    if (isWorkerClockedIn) {
      return false;
    }

    return isDefined(trackingUrl);
  }

  return (
    <Card variant="outlined" sx={{ backgroundColor: "#FAFAFA" }}>
      <CardHeader
        title={
          <Stack
            direction={isSmallScreen ? "column" : "row"}
            justifyContent="space-between"
            spacing={isSmallScreen ? 2 : undefined}
          >
            <Stack direction="row" gap={1} alignItems="center">
              <CbhIcon type="navigation-arrow" size="small" />
              <Text variant="h3">Live tracking</Text>
            </Stack>
            <ShiftBoardLiveTrackerCardHeader />
          </Stack>
        }
      />
      {shouldShowLiveTrackerView() && (
        <CardContent sx={{ paddingTop: 0 }}>
          <ShiftBoardLiveTrackerMapView />
        </CardContent>
      )}
    </Card>
  );
}
